export interface QuizConfig {
  correctAdvanceDelayMs: number;
  incorrectRevealMs: number;
  repeatOnWrong: boolean;
  mistakeWeightIncrement: number;
  maxMistakeWeight: number;
}

export const DEFAULT_QUIZ_CONFIG: QuizConfig = {
  correctAdvanceDelayMs: 500,
  incorrectRevealMs: 800,
  repeatOnWrong: true,
  mistakeWeightIncrement: 1,
  maxMistakeWeight: 3,
};
